module.exports = __webpack_public_path__ + "static/media/icon_file_extension.1d923d29.svg";